import React, { useState, useEffect } from 'react';
import { GET_MEMBERSHIP_DATA, PRODUCT_IDS } from "../helpers/Constant";
import { getDataWithToken } from '../api/api';
import { useTranslation } from 'react-i18next';
import Loader from '../common/loader';
import BackButton from '../common/backButton';
import { Splide, SplideSlide } from '@splidejs/react-splide';

function GamePass() {
    const { t } = useTranslation();
    const [membershipFeatures, setMembershipFeatures] = useState([]);
    const [monthlyPlan, setMonthlyPlan] = useState(0);
    const [annualPlan, setAnnualPlan] = useState(0);
    const [loading, setLoading] = useState(true);
    
    const options = {
        pagination: true,
        type: 'loop',
        autoplay: false,
        speed: 500,
        perPage: 2,
        perMove: 1,
        arrows: false,
    };

    useEffect(() => {
        async function fetchMembershipData() {
            try {
                const response = await getDataWithToken(GET_MEMBERSHIP_DATA);
                if(response) {
                   if(response.membership_annual_fee) {
                    setAnnualPlan(response.membership_annual_fee);
                   }
                   if(response.membership_monthly_fee) {
                    setMonthlyPlan(response.membership_monthly_fee);
                   }
                   if(response.membership_features) {
                    setMembershipFeatures(response.membership_features);
                   }
                } else {
                    setMembershipFeatures([]);
                }
                setLoading(false);
            } catch (error) {
                setLoading(false);
            }
        }
        fetchMembershipData()
    }, []);

    const handleBuyMonthlyMembership = (plan) => {
        setLoading(true);
        const url = `uniwebview://buyRequest?itemBundleID=${PRODUCT_IDS.MONTHLY_SUBSCRIPTION}`;
        window.location.href = url;
    }

    const handleBuyAnnualMembership = (plan) => {
        setLoading(true);
        const url = `uniwebview://buyRequest?itemBundleID=${PRODUCT_IDS.YEARLY_SUBSCRIPTION}`;
        window.location.href = url;
    }

    window.buyRequestSuccess = (itemBundleID) => {
        alert('buy request success');
        console.log('buy request success', itemBundleID);
        setLoading(false);
    }

    window.buyRequestFailed = (itemBundleID) => {
        alert('buy request failed');
        console.log('buy request failed', itemBundleID);
        setLoading(false);
    }

    return (
        <>
            <div className='wrapper h-100 px-0'>
                {loading && <Loader />}

                <div className="px-3">
                    <BackButton label={t('Home')} />
                </div>

                <div className='membership_wrapper'>
                    <div className='membership_heading_wrapper position-relative'>
                        <div className='membership_heading text-center position-relative z-1'>
                            <h1 className='membership_title fw-bold mb-0'>{t('GAME PASS')}</h1>
                        </div>
                        <div className='game_pass_round_wrapper position-absolute top-50 start-50 translate-middle'>
                            <div className='game_pass_round game_pass_round_1 rounded-pill pe-none position-absolute top-50 start-50 translate-middle'></div>
                            <div className='game_pass_round game_pass_round_2 rounded-pill pe-none position-absolute top-50 start-50 translate-middle'></div>
                            <div className='game_pass_round game_pass_round_3 rounded-pill pe-none position-absolute top-50 start-50 translate-middle'></div>
                            <div className='game_pass_round game_pass_round_4 rounded-pill pe-none position-absolute top-50 start-50 translate-middle'></div>
                        </div>
                    </div>
                    <div className='pt-1 text-center position-relative z-1'>
                        <h4 className='membership_unlock fw-light p-2 mt-3 mb-4 text-uppercase'>Unlocked all Games</h4>
                    </div>
                    <Splide options={options}>
                        <SplideSlide>
                            <div className='game_pass_item'>
                                <div className='game_pass_card'>
                                    <img className='img-fluid w-100' src='../images/game-blackmoor.jpg' alt='Game' />
                                </div>
                                <div className='game_pass_card'>
                                    <img className='img-fluid w-100' src='../images/game-slice-master.jpg' alt='Game' />
                                </div>
                            </div>
                        </SplideSlide>
                        <SplideSlide>
                            <div className='game_pass_item'>
                                <div className='game_pass_card'>
                                    <img className='img-fluid w-100' src='../images/game-geometry-dash.jpg' alt='Game' />
                                </div>
                                <div className='game_pass_card'>
                                    <img className='img-fluid w-100' src='../images/game-jump-star.jpg' alt='Game' />
                                </div>
                            </div>
                        </SplideSlide>
                        <SplideSlide>
                            <div className='game_pass_item'>
                                <div className='game_pass_card'>
                                    <img className='img-fluid w-100' src='../images/game-blackmoor.jpg' alt='Game' />
                                </div>
                                <div className='game_pass_card'>
                                    <img className='img-fluid w-100' src='../images/game-slice-master.jpg' alt='Game' />
                                </div>
                            </div>
                        </SplideSlide>
                        <SplideSlide>
                            <div className='game_pass_item'>
                                <div className='game_pass_card'>
                                    <img className='img-fluid w-100' src='../images/game-geometry-dash.jpg' alt='Game' />
                                </div>
                                <div className='game_pass_card'>
                                    <img className='img-fluid w-100' src='../images/game-jump-star.jpg' alt='Game' />
                                </div>
                            </div>
                        </SplideSlide>
                    </Splide>
                    <div className='membership_feedback fw-light text-center mt-3'>More Game Soon.. <br/>All In One Pack</div>
                    <div className='membership_btn d-flex flex-column align-items-center gap-3 mt-4 px-3'>
                        <button className='membership_button fw-bold d-flex justify-content-between w-100' onClick={handleBuyMonthlyMembership}>
                            <div className='membership_button_left d-flex flex-column justify-content-center align-items-start'>
                                <span className='membership_button_month'>1 month</span>
                            </div>
                            <div className='membership_button_right d-flex flex-column justify-content-center align-items-end'>
                                <span className='membership_button_price'>$ {monthlyPlan || 9.99}</span>
                            </div>
                        </button>
                        <button className='membership_button fw-bold d-flex justify-content-between w-100' onClick={handleBuyAnnualMembership}>
                            <div className='membership_button_left d-flex flex-column justify-content-center align-items-start'>
                                <span className='membership_button_month'>12 month</span>
                                <span className='membership_button_role d-inline-block fw-medium rounded-corners text-uppercase'>Popular</span>
                            </div>
                            <div className='membership_button_right d-flex flex-column justify-content-center align-items-end'>
                                <span className='membership_button_old_price text-uppercase'><del>$ {parseFloat(monthlyPlan || 9.99) * 12 || 99.99}</del></span>
                                <span className='membership_button_price'>$ {annualPlan || 59.99}</span>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}
export default GamePass